<div class="container-fluid">
    <div class="row pt-4 pl-4" style="font-size: 22px !important;
    font-weight: 400;
    color: #424242;">
      <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;MIS Report</h5>
    </div>
  <div id="mainContent" class="container">
    <div class="modal-body">
      
        <div class="row">
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4">
                <label for="approversName" class="col-form-label"
                  >Financial Year</label>
              </div>
              <div class="col-sm-6">
                <select
                  class="form-control form-control-xs mt-1"
                  [(ngModel)]="selectedFinancialYear">
                  <option value=null>Select Year</option>
                  <option *ngFor="let selectedFinancialYear of financialList" [ngValue]="selectedFinancialYear">
                    {{ selectedFinancialYear.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <label class="col-sm-4 col-form-label">Quarter</label>
              <div class="col-sm-6">
                  <mat-form-field appearance="legacy" style="width: 100%">
                    <mat-select
                      multiple
                      [(ngModel)]="selectedQuarter"
                      #designateQuarter="ngModel"
                    >
                      <mat-option
                        #quarterChecked
                        (click)="selectAllQuarter(designateQuarter, QuarterList)"
                        [value]="0"
                        >Select All
                      </mat-option>
                      <mat-option
      
                        #quarterChecked
                        *ngFor="let quarter of QuarterList"
                        [value]="quarter"
                      >
                        {{ quarter.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <label class="col-sm-4 col-form-label">Partner</label>
              <div class="col-sm-6">
                <mat-form-field appearance="legacy" style="width: 100%" >
                  <mat-select
                    multiple
                    [(ngModel)]="selectedPartner"
                    #designatePartner="ngModel"
                  >
                    <mat-option
                      (click)="selectAllPartner(designatePartner, partnerList)"
                      [value]="0"
                      >Select All
                    </mat-option>
                    <mat-option #item *ngFor="let partner of partnerList" [value]="partner">
                      {{ partner.firstName }} {{partner.middleName}} {{ partner.lastName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
             </div> 
            </div>
          </div>
        </div>
  
        <div class="row mt-3">
          <div class="col-sm-4">
            <div class="row">
             
            </div>
          </div>
  
          <div class="col-sm-4">
            <div class="row">
           
            </div>
          </div>
          <div class="col-sm-2">
            <button (click)="exportToExcelClick()" class="btn btn-sm btn-block btn-outline-theme">
              <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
            </button>
          </div>
        </div>
    </div>
  </div>
  </div>